import { apiClient } from "@/shared/api/client"
import type { AuditLogFilters, AuditLogPage } from "./types"

const PAGE_SIZE = 50

export const auditLogKeys = {
	list: (filters: AuditLogFilters) => ["audit-logs", filters] as const,
}

export const listAuditLogs = async (filters: AuditLogFilters, cursor?: string) => {
	const params = Object.fromEntries(
		Object.entries({ ...filters, cursor, limit: PAGE_SIZE }).filter(
			([, value]) => value !== undefined && value !== "",
		),
	)

	return (await apiClient.get<AuditLogPage>("/admin/audit-logs", { params })).data
}
